import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthenticatedHttpService } from './authenticatedhttp.service';

import { Facility } from '../model/facility';
import { ProductLine } from '../model/product-line';

import { ApplicationStateService } from './application-state.service';
import { UserFavoritesService } from './user-favorites.service';

import * as _ from 'lodash';

@Injectable()
export class FacilityService {
    private baseUrl;
    private _facilityCache: Facility[];
    private _facilityCacheCopy: Facility[];
    ////private _productLineFavoriteCache: ProductLineFavorites[];
    
    constructor(
        private _http: AuthenticatedHttpService,
        private applicationStateService: ApplicationStateService,
        private userFavoritesService: UserFavoritesService
    ) {
        this.baseUrl = _http.getBaseURLFromCookie();
    }

    facilityFilter = (fac: Facility, showFaves: boolean) => {
        fac.ProductLines = fac.ProductLines.filter(x => x.Metadata.NumberOfModels > 0);
        fac.ProductLines = fac.ProductLines.filter(x => x.Metadata.NumberOfOptions > 0);
        fac.ProductLines = fac.ProductLines.filter(pl => {
            if (showFaves) {
                return pl.Favorite;
            }
            else {
                return true;
            }
        });

        let hasProductLines = fac.ProductLines.length > 0;
        return hasProductLines;
    };

    searchFilter = function (fac: Facility, search: string) {
        if (fac === undefined) return false;

        fac.ProductLines = fac.ProductLines.filter(pl => {
            if (pl.ProductLineDescription === undefined || pl.ProductLineDescription === '') return false;

            return pl.ProductLineDescription.toLocaleLowerCase().indexOf(search) !== -1;
        });

        return fac.ProductLines.length > 0;
    };

    // Get a list of facilities. 
    // refresh: whether to pull fresh from the database
    getFacilities(showOnlyFavorites: boolean, refresh = false): Observable<Facility[]> {
        if (this._facilityCache && !refresh) {
            return Observable.of(this._facilityCache)
                .map(facs => {
                    this._facilityCache = _.cloneDeep(this._facilityCacheCopy);
                    return facs.filter(x => this.facilityFilter(x, showOnlyFavorites));
                });
        } else {
			return this._http.get(`${this.baseUrl}/api/facilities/`)
				.map(x => x.json())
				.flatMap((facs: Facility[]) => {

					let userId = this.applicationStateService.getApplicationState().userId;
					return this.userFavoritesService.getProductLineFavorites(userId).map(
						plf => {
							//this._productLineFavoriteCache = plf;
							let productLines = _.flatMap(facs, (value) => {
								return value.ProductLines;
							});
							let keyedProductLines = _.keyBy(productLines, pl => {
								return pl.ProductLineId;
							});
							plf.forEach(thisFavorite => {
								let fromCache = keyedProductLines[thisFavorite.ProductLineId];
								if (fromCache !== undefined) {
									fromCache.Favorite = true;
								}
							});
							return facs;
						}
					);
				})
				.map(facs => {
					this._facilityCache = facs;
					this._facilityCacheCopy = _.cloneDeep(this._facilityCache);

					return this._facilityCache.filter(x => this.facilityFilter(x, showOnlyFavorites));
				})
				.catch(this._http.handleError);
        }
    }

    mergeFavoriteUnfavorite(productLineId: number, favorite: boolean): Observable<ProductLine> {
        let productLines = _.flatMap(this._facilityCache, (value) => {
            return value.ProductLines;
        });
        let keyedProductLines = _.keyBy(productLines, pl => {
            return pl.ProductLineId;
        });
        let mergeProductLine = keyedProductLines[productLineId];
        if (mergeProductLine !== undefined) {
            mergeProductLine.Favorite = favorite;
        }
        productLines = _.flatMap(this._facilityCacheCopy, (value) => {
            return value.ProductLines;
        });
        keyedProductLines = _.keyBy(productLines, pl => {
            return pl.ProductLineId;
        });
        mergeProductLine = keyedProductLines[productLineId];
        if (mergeProductLine !== undefined) {
            mergeProductLine.Favorite = favorite;
        }
        return Observable.of(mergeProductLine);
    }

    getFacilitiesByRetailerNumber(retailerNumber: string, currentUserId: number, showOnlyFavorites: boolean, refresh = false): Observable<Facility[]> {
        if (this._facilityCache && !refresh) {
            return Observable.of(this._facilityCache)
                .map(facs => {
                    this._facilityCache = _.cloneDeep(this._facilityCacheCopy);
                    return facs.filter(x => this.facilityFilter(x, showOnlyFavorites));
                });
        } else {
            return this._http.get(`${this.baseUrl}/api/retailer/${retailerNumber}/facilities`)
                .map(x => x.json())
                .flatMap((facs: Facility[]) => {
                    return this.userFavoritesService.getProductLineFavorites(currentUserId, true).map(
                        plf => {
                            //this._productLineFavoriteCache = plf;
                            let productLines = _.flatMap(facs, (value) => {
                                return value.ProductLines;
                            });
                            let keyedProductLines = _.keyBy(productLines, pl => {
                                return pl.ProductLineId;
                            });
                            plf.forEach(thisFavorite => {
                                let fromCache = keyedProductLines[thisFavorite.ProductLineId];
                                if (fromCache !== undefined) {
                                    fromCache.Favorite = true;
                                }
                            });
                            return facs;
                        }
                    );
                })
                .map(facs => {
                    this._facilityCache = facs;
                    this._facilityCache.forEach(fac => { fac.PlantDescription = fac.PlantDescription.trim(); fac.ProductLines.forEach(pli => { pli.ProductLineDescription = pli.ProductLineDescription.trim(); }); })
                    this._facilityCacheCopy = _.cloneDeep(this._facilityCache);

                    return this._facilityCache.filter(x => this.facilityFilter(x, showOnlyFavorites));
                })
                .catch(this._http.handleError);
        }
    }

    getFacilitiesForModelsBAQAdmin(): Observable<Facility[]> {
        return this._http.get(`${this.baseUrl}/api/facilities/baqmodels`)
            .map(x => { return x.json() })
            .catch(this._http.handleError);

    }

    getFacilitiesListOnly(): Observable<Facility[]> {
        //let facilityList = new Array<Facility>();
        return this._http.get(`${this.baseUrl}/api/facilities`)
            .map(x => { return x.json() })
            .catch(this._http.handleError);
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/facility.service.ts